module.exports = __webpack_public_path__ + "img/bg-inner.829a03cb.webp";